<template>
  <div class="iv-message">
    <div class="iv-main-width iv-p-t-20">
      <Tab :navList="navList" @on-click="tabClick">
      </Tab>
      <component ref="learnContent" :is="learnContent" :name="learnContent" @onloaded="onloaded"></component>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import historyDone from './history-done'

export default {
  data () {
    return {
      learnContent: 'historyDone'
    }
  },
  created () {
    this.initTabs()
  },
  methods: {
    onloaded () {},
    tabClick (name) {
      this.learnContent = 'historyDone'
    },
    initTabs () {
      this.navList = [{
        label: '查看历史归档已办',
        name: 'history'
      }]
    }
  },
  components: {
    Tab,
    historyDone
  }
}
</script>

<style lang="scss" scoped>
.iv-message {
  height: 100%;;
  background-color: #fff;
  /deep/ .iv-drag-table {
    .ivu-table-row {
      .ivu-table-cell {
        font-size: 16px;
        color: rgba($color: #000000, $alpha: 0.65);
      }
    }
  }
}
.iv-p {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 400;
}
</style>
